import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AdminLayout from '../components/AdminLayout';
import LoadingSpinner from '../components/LoadingSpinner';
import toast from 'react-hot-toast';
import { API_BASE_URL, EMPTY_SETTINGS, GENERIC_FIELDS, fieldClass } from '../discovery/fields';

const DiscoverySettings = () => {
  const [settings, setSettings] = useState(EMPTY_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [pending, setPending] = useState(false);
  const [showKeys, setShowKeys] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_BASE_URL}/api/admin/discovery/settings`)
      .then((response) => {
        if (!cancelled) setSettings({ ...EMPTY_SETTINGS, ...(response.data.data || {}) });
      })
      .catch((error) => {
        toast.error(error.response?.data?.error || 'Discovery settings could not be loaded.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const save = async (event) => {
    event.preventDefault();
    setPending(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/admin/discovery/settings`, settings);
      setSettings({ ...EMPTY_SETTINGS, ...(response.data.data || settings) });
      toast.success('Discovery settings saved');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Discovery settings could not be saved.');
    } finally {
      setPending(false);
    }
  };

  return (
    <AdminLayout>
      <Link to="/discovery" className="text-sm font-medium text-primary-700 hover:text-primary-800">
        All sessions
      </Link>
      <h1 className="mt-3 text-2xl font-semibold text-gray-900">Discovery settings</h1>
      <p className="mt-1 max-w-xl text-sm text-gray-500">
        These values are the defaults for every enrollment file. A session can replace any of them when you create its file.
      </p>
      {loading ? (
        <div className="mt-16">
          <LoadingSpinner />
        </div>
      ) : (
        <form className="mt-8 max-w-xl space-y-5" onSubmit={save}>
          {GENERIC_FIELDS.map((field) => (
            <div key={field.key}>
              <label htmlFor={field.key} className="block text-sm font-medium text-gray-700">
                {field.label}
              </label>
              <input
                id={field.key}
                className={fieldClass}
                type={field.secret && !showKeys ? 'password' : 'text'}
                autoComplete="off"
                value={settings[field.key] || ''}
                placeholder={field.placeholder}
                onChange={(event) => setSettings((current) => ({ ...current, [field.key]: event.target.value }))}
              />
              <p className="mt-1 text-sm text-gray-500">{field.hint}</p>
            </div>
          ))}
          <label className="flex items-center gap-2 text-sm text-gray-600">
            <input type="checkbox" checked={showKeys} onChange={(event) => setShowKeys(event.target.checked)} />
            Show keys
          </label>
          <button
            type="submit"
            className="inline-flex h-9 items-center rounded-md bg-primary-600 px-3 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50"
            disabled={pending}
          >
            {pending ? 'Saving…' : 'Save settings'}
          </button>
        </form>
      )}
    </AdminLayout>
  );
};

export default DiscoverySettings;
